import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/coaching/')({
  component: () => <PageStub title="Guidance Calls" description="Coaching and mentoring sessions" />,
});
